import { Commons } from './commons'
import { Events } from './events'
import defaultPreferences from './raws/defaultPreferences.json'
import keysNotToCleanWhenLogout from './raws/keysNotToCleanWhenLogout.json'

class QuickStorage {
  static init() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    QuickStorage.loadInMemory()
    QuickStorage.initListener()
    QuickStorage.loadUserPreferences()
  }

  static loadInMemory() {
    window.quick_storage = { ...localStorage }
  }

  static loadUserPreferences() {
    const userPreferences = window.userPreferences || defaultPreferences
    Object.keys(userPreferences).forEach(key => {
      const stored = QuickStorage.getStored(key)
      if (Commons.isEmpty(stored)) return
      userPreferences[key] = stored
    })
    window.userPreferences = userPreferences
  }

  static initListener() {
    Events.handleEvent('logout_requested', () => {
      QuickStorage.storeData('user_connected', false)
      QuickStorage.cleanStoredData()
    })
    Events.handleEvent('login_done', () => {
      QuickStorage.storeData('user_connected', true)
    })
    Events.handleEvent('registration_done', () => {
      QuickStorage.storeData('user_connected', true)
    })
    Events.handleEvent('worker_activated', async () => {
      const userData = await new Promise(resolve => {
        Events.sendDataRequest('userData', resolve)
        setTimeout(resolve, 1000, null)
      })
      const userConnected = !!userData?.reference
      QuickStorage.storeData('user_connected', userConnected)
    })
    Events.handleEvent('request:userPreferences', ({ responseId }) => {
      if (!window.userPreferences) QuickStorage.loadUserPreferences()
      Events.dispatchEvent(responseId, window.userPreferences)
    })
    Events.handleEvent('user_preferences_setted', async newData => {
      Object.keys(newData).forEach(key => {
        QuickStorage.storeData(key, newData[key])
      })
      QuickStorage.loadUserPreferences()
      Events.dispatchEvent('user_preferences_updated')
    })
  }

  static storeData(name, value) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return
    window.localStorage.setItem(name, JSON.stringify(value))
    QuickStorage.loadInMemory()
  }

  static getStored(name) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return null
    const data = window.quick_storage[name]
    // const data = window.localStorage.getItem(name)
    if (!data) return null
    return JSON.parse(data)
  }

  static checkStored(name) {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return false
    if (!stored[name]) {
      console.error(`key ${name} not available in storable keys`)
      return false
    }
    const dataStored = QuickStorage.getStored(name)
    return !!dataStored
  }

  static cleanStoredData() {
    const notToClear = {}
    keysNotToCleanWhenLogout.forEach(key => {
      notToClear[key] = QuickStorage.getStored(key)
    })
    window.localStorage.clear()
    keysNotToCleanWhenLogout.forEach(key => {
      QuickStorage.storeData(key, notToClear[key])
    })
    QuickStorage.loadInMemory()
  }
}

const textes = {}

export { QuickStorage }
